<ng-select (blur)="onTouch()"
           (ngModelChange)="onChange($event)"
           [items]="items"
           [loading]="loading"
           [ngClass]="!control?.valid?'ng-invalid':''"
           [ngModel]="value"
           appendTo="body"
           bindLabel="label"
           bindValue="value"
           class="size-medium status-basic"
></ng-select>
